<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-img :src="bannerPng" aspect-ratio="2.75" />
          <v-card-title class="justify-center" primary-title>
            <div>
              <h3 class="headline mb-0">{{ $m.not_found_message }}</h3>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import bannerPng from "@/assets/images/banner.png";

export default defineComponent({
  name: "NotFound",
  setup() {
    return {
      bannerPng: bannerPng,
    };
  },
});
</script>
